import { Injectable } from '@angular/core';
import { environment as env } from '../../../../environments/environment';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { LocalStorageService } from '../localstorage.service';

@Injectable({
    providedIn: 'root'
})
export class SignInService {
    constructor(private dataCollectorService: DataCollectorService,
                private localStorageService: LocalStorageService) {}
    dcConfigUrl(): string{
        return `${env.baseURL}/config`;
    }

    loginCheckUrl(companyName: string, dcApiUrl?: string): string{
        if(dcApiUrl){
            return`${dcApiUrl}/api/sso/${companyName}/login-check`;
        }
        return `${this.localStorageService.getLocalStorage('dc_api_url')}/api/sso/${companyName}/login-check`;
    }

    loginUrl(dcApiUrl?: string): string{
        if(dcApiUrl){
            return`${dcApiUrl}/api/user/login`;
        }
        return `${this.localStorageService.getLocalStorage('dc_api_url')}/api/user/login`;
    }

    forgetPwdUrl(): string{
        return `${this.localStorageService.getLocalStorage('dc_api_url')}/api/user/forgot_password`;
    }

    resetPwdUrl(): string{
        return `${this.localStorageService.getLocalStorage('dc_api_url')}/api/user/reset_password`;
    }

    logoutUrl(): string{
        return `${this.localStorageService.getLocalStorage('dc_api_url')}/api/user/logout?device_id=${this.localStorageService.getLocalStorage('device_id')}`;
    }

    sendOTPUrl(): string{
        return `${this.localStorageService.getLocalStorage('dc_api_url')}/api/user/login/send_otp`;
    }

    updateCompanyConfiguration(company: any, configuration: any): void {
        this.localStorageService.setLocalStorage('dc_api_url',configuration.config.dc_api_url);
        this.localStorageService.setLocalStorage('dc_wss_url',configuration.config.dc_socket_url);
        if(configuration?.config?.dc_workflow_builder_url){
            this.localStorageService.setLocalStorage('dc_workflow_builder_url',configuration.config.dc_workflow_builder_url);
        }
        if(configuration.config.dc_connect_url){
            // Will be null in APAC region,
            this.localStorageService.setLocalStorage('dc_connect_url', configuration.config.dc_connect_url);
        }
        this.localStorageService.setLocalStorage('dc_region',configuration.config.dc_api_url.replace('https://','').split('.')[0]);
        this.localStorageService.setLocalStorage('company_login_name', company);
    }

    updateSSOConfiguration(sso: any): void{
        this.localStorageService.setLocalStorage('sso_enabled',sso?.data?.sso_enabled);
        this.localStorageService.setLocalStorage('mandate_sso',sso?.data?.mandate_sso);
    }
}
